import { Card } from './abstractCard.model';

export class FateCard extends Card {}
